import { memo } from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  message: string;
}

export const ErrorDisplay = memo(({ message }: ErrorDisplayProps) => (
  <div className="flex flex-col items-center justify-center p-6 text-[var(--anl-error)]">
    <AlertCircle className="mb-2 h-10 w-10" aria-hidden="true" />
    <h3 className="mb-1 text-lg font-medium text-[var(--anl-text)]">Error Loading Devices</h3>
    <p className="text-center text-[var(--anl-text)]">{message}</p>
    <p className="mt-4 text-sm text-[var(--anl-text-muted)]">
      Please try again later or contact support if the issue persists.
    </p>
  </div>
));

ErrorDisplay.displayName = 'ErrorDisplay';
